import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import {
	DonationPage,
	MapIndexPage,
	MapReturnsPage,
	MapStructurePage,
	MapCorrelationsPage,
	ScreenerPage,
	AuthSignInPage,
	SubscriptionSelectPage,
	SubscriptionPayPage,
	DevPage,
	SubscriptionCompletePage,
	EtfDocumentsPage,
	EtfFactorAnalysisPage,
	EtfCorrelationsPage,
	DiscountsPage, 
	EtfAssetsPage
} from './pages';
import { initPluggins } from 'shared/mechanics/plugin';

import {
	ChatBroPlugin,
	GoogleAnalyticsPlugin,
	GoogleAdsPlugin,
	YandexAnalyticsPlugin,
	YandexAdsPlugin,
	SentryPlugin
} from 'integrations';

import './index.scss';
import moment from 'moment';
import 'moment/locale/ru'
import { AuthService } from 'shared/mechanics/auth';

moment.locale('ru');

initPluggins(
	ChatBroPlugin,
	GoogleAnalyticsPlugin,
	GoogleAdsPlugin,
	YandexAnalyticsPlugin,
	YandexAdsPlugin,
	SentryPlugin);

const refreshAuthMinutes = parseInt(process.env.REACT_APP_AUTH_REFRESH_MINUTES!);


AuthService.refresh();
setInterval(() => { AuthService.refresh() }, refreshAuthMinutes * 60 * 1000)

const userAuthorization = AuthService.resolveUserAuthorization();
if (userAuthorization.isBlocked) {
	ReactDOM.render(
		<React.StrictMode>
			<div>blocked</div>
		</React.StrictMode>,
		document.getElementById('root')
	);
}
else {
	ReactDOM.render(
		<React.StrictMode>
			<BrowserRouter>
				<Switch>
					<Route path="/screener" component={ScreenerPage} />
					<Route path="/map" exact component={MapIndexPage} />
					<Route path="/map/structure" component={MapStructurePage} />
					<Route path="/map/returns" component={MapReturnsPage} />
					<Route path="/map/correlation" component={MapCorrelationsPage} />
					<Route path="/donation" component={DonationPage} />
					<Route path="/auth/signin" component={AuthSignInPage} />
					<Route path="/subscription/select" component={SubscriptionSelectPage} />
					<Route path="/subscription/pay/:invoiceId" component={SubscriptionPayPage} />
					<Route path="/subscription/complete" component={SubscriptionCompletePage} />
					<Route path="/etf/:ticker/documents" component={EtfDocumentsPage} />
					<Route path="/etf/:ticker/analysis/factor" component={EtfFactorAnalysisPage} />
					<Route path="/etf/:ticker/correlations" component={EtfCorrelationsPage} />
					<Route path="/etf/:ticker/assets" component={EtfAssetsPage} />
					<Route path="/discounts" component={DiscountsPage} />
					<Route path="/dev" component={DevPage} />
				</Switch>
			</BrowserRouter>
		</React.StrictMode>,
		document.getElementById('root')
	);
}


